// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Form from '@cloudscape-design/components/form';
import FormField from '@cloudscape-design/components/form-field';
import Header from '@cloudscape-design/components/header';
import Input from '@cloudscape-design/components/input';
import Link from '@cloudscape-design/components/link';
import { useEffect, useState } from 'react';

const _preserve = React.version;


import SpaceBetween from '@cloudscape-design/components/space-between';
import { mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, getUser, setData, setLoading } from '../../../commons/functions';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../layout';

export const UserPasswordPage = () => {
    const { idUser, menu, data } = useGlobalState();
    const [status, setStatus] = useState<any>();

    const handleValidation = async () => {
        if (status?.pwd?.length == 0) {
            addNotification("Contraseña no puede estar vacía", "warning", setData);
            return
        }
        setStatus({ ...status, pwdShow: false })
        setLoading(true);
        try {

            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/public/login/step2',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    phone: getUser(idUser, data).phone1,
                    password: status?.pwd,
                }),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);

            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code == 0) {
                setStatus({ ...status, step: 2, pwdShow: false });
                //console.log(data)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false);
        }
    }

    const handleUpdate = async () => {
        try {
            setStatus({ ...status, pwdShow1: false, pwdShow2: false })
            setLoading(true);
            const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/profile/mod.pwd',
                    'JWT': getCookie("JWT"),
                    // 
                },
                body: JSON.stringify({
                    password: status?.pwd,
                    newPassword: status?.pwd1,
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setStatus({ step: 1, error: "", pwd: "", pwd1: "", pwd2: "", showPwd: false, showPwd1: false, showPwd2: false, validation: [] })
                window.location.hash = "#home"
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setStatus({ step: 1, error: "", pwd: "", pwd1: "", pwd2: "", showPwd: false, showPwd1: false, showPwd2: false, validation: [] })
    }, []);
    useEffect(() => {
        if (status && status.step === 2) {
            validatePassword(status.pwd1);
        }
    }, [status?.pwd1]);

    const validatePassword = (passwordToCheck: string) => {
        const newErrors: string[] = [];
        if (passwordToCheck.length === 0) {
            setStatus({ ...status, validation: newErrors });
            return;
        }
        if (passwordToCheck.length < 8) {
            newErrors.push('Al menos 8 caracteres');
        }

        if (!/[#\$%\^&\*\(\)\-\+\=\[\]\{\}\\\|\;\:\'\"\,\<\>\.\/\?]/.test(passwordToCheck)) {
            newErrors.push('Debe incluir al menos un símbolo (ej: # $ . ?)');
        }
        if (!/(?=.*[a-z])/.test(passwordToCheck)) {
            newErrors.push('Debe incluir al menos una letra minúscula');
        }
        if (!/(?=.*[A-Z])/.test(passwordToCheck)) {
            newErrors.push('Debe incluir al menos una letra mayúscula');
        }
        if (!/(?=.*\d)/.test(passwordToCheck)) {
            newErrors.push('Debe incluir al menos un número');
        }
        if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#\$%\^&\*\(\)\-\+\=\[\]\{\}\\\|\;\:\'\"\,\<\>\.\/\?])/.test(passwordToCheck)) {
            //   newErrors.push('Debe incluir una mezcla de letras mayúsculas y minúsculas, números y símbolos');
        }

        setStatus({ ...status, validation: newErrors });
    }


    return (
        <>
            <CustomAppLayout
                breadcrumbs={
                    <BreadcrumbGroup
                        items={buildBreadcrumbItems(menu)}
                        expandAriaLabel="Show path"
                        ariaLabel="Breadcrumbs"
                    />
                }
                toolsHide={true}
                contentType="form"
                content={
                    <SpaceBetween size="l">
                        {!!status && (
                            <div style={{ maxWidth: '450px' }}>
                                <Container header="Modificar contraseña">
                                    <Form
                                        actions={
                                            <Button onClick={status?.step === 1 ? handleValidation : handleUpdate}
                                                disabled={
                                                    (status?.step === 1 && status?.pwd?.length < 5)
                                                    || (status?.step === 2 && (status?.pwd1?.length < 8 || status?.pwd2 !== status?.pwd1))
                                                } variant="primary">{
                                                    status.step === 1 ? "Siguiente" : "Modificar"}</Button>
                                        }
                                        secondaryActions={
                                            status?.step === 2 && (
                                                <Button onClick={() =>
                                                    setStatus({
                                                        ...status,
                                                        pwd: "",
                                                        pwd1: "",
                                                        pwd2: "",
                                                        showPwd: false,
                                                        showPwd1: false,
                                                        showPwd2: false,
                                                        error: "",
                                                        step: 1
                                                    })
                                                } variant="normal">Atrás</Button>
                                            )
                                        }
                                        header={
                                            <Header variant="h1"
                                            >Modificar contraseña
                                            </Header>
                                        }
                                    >
                                        {status.step === 1 && (
                                            <FormField
                                                label="Contraseña actual"
                                                info={
                                                    <Link onClick={() => setStatus({ ...status, pwdShow: !status.pwdShow })}>
                                                        {status.pwdShow ? <Icon path={mdiEyeOutline} size={0.75} /> : <Icon path={mdiEyeOffOutline} size={0.75} />}
                                                    </Link>
                                                }
                                                constraintText="Indique su actual contraseña para validacion.">

                                                <Input
                                                    value={status?.pwd || ''}
                                                    onChange={(e) => setStatus({ ...status, pwd: e.detail.value })}
                                                    autoComplete="off"
                                                    type={status.pwdShow ? 'text' : 'password'}

                                                />
                                            </FormField>
                                        )}
                                        {status.step === 2 && (
                                            <SpaceBetween direction="vertical" size="l">
                                                <FormField
                                                    label="Nueva contraseña"
                                                    constraintText={status.validation?.join(', ')}
                                                    info={
                                                        <Link onClick={() => setStatus({ ...status, pwdShow1: !status.pwdShow1 })}>
                                                            {status.pwdShow1 ? <Icon path={mdiEyeOutline} size={0.75} /> : <Icon path={mdiEyeOffOutline} size={0.75} />}
                                                        </Link>
                                                    }
                                                >
                                                    <Input
                                                        value={status?.pwd1 || ''}
                                                        onChange={(e) => setStatus({ ...status, pwd1: e.detail.value })}
                                                        autoComplete="off"
                                                        type={status.pwdShow1 ? 'text' : 'password'}

                                                    />
                                                </FormField>

                                                <FormField
                                                    label="Confirmación"
                                                    info={
                                                        <Link onClick={() => setStatus({ ...status, pwdShow2: !status.pwdShow2 })}>
                                                            {status.pwdShow2 ? <Icon path={mdiEyeOutline} size={0.75} /> : <Icon path={mdiEyeOffOutline} size={0.75} />}
                                                        </Link>
                                                    }
                                                >
                                                    <Input
                                                        value={status?.pwd2 || ''}
                                                        onChange={(e) => setStatus({ ...status, pwd2: e.detail.value })}
                                                        autoComplete="off"
                                                        type={status.pwdShow2 ? 'text' : 'password'}

                                                    />
                                                </FormField>
                                            </SpaceBetween>
                                        )}
                                    </Form>
                                </Container>
                            </div>
                        )}

                    </SpaceBetween>
                }
            />
        </>
    );
};

